import { Typography } from '@mui/material'
import { GridOverlay, GridOverlayProps } from '@mui/x-data-grid-pro'

interface NoRowsOverlayProps extends GridOverlayProps {
	message?: string
}

function NoRowsOverlay({ message = 'No Rows Found', ...props }: NoRowsOverlayProps) {
	return (
		<GridOverlay {...props}>
			<Typography>{message}</Typography>
		</GridOverlay>
	)
}

const TableOverlays = {
	NoRowsOverlay,
}

export default TableOverlays
